import {
  apiClient
} from "./chunk-HCVPNQUB.mjs";

// src/ops/outboxApi.ts
import { OutboxService } from "@maat/api-shared";
var OUTBOX_SERVICE_PATH = {
  [OutboxService.Main]: "/main",
  [OutboxService.Booking]: "/booking",
  [OutboxService.Payment]: "/payment",
  [OutboxService.Chat]: "/chat",
  [OutboxService.Ical]: "/ical-sync",
  [OutboxService.Pricing]: "/pricing"
};
var base = (service) => `${OUTBOX_SERVICE_PATH[service]}/api/admin/outbox`;
var outboxApi = {
  list: async (service, params) => apiClient.get(base(service), { params }),
  stats: async (service, windowHours) => apiClient.get(`${base(service)}/stats`, {
    params: { windowHours }
  }),
  getById: async (service, id) => apiClient.get(`${base(service)}/${id}`),
  replay: async (service, id) => apiClient.post(`${base(service)}/${id}/replay`)
};

export {
  outboxApi
};
